/**
 * Created by mqamhieh on 3/28/18.
 */
(function () {

    angular.module('harriApp')
        .controller('JobAlertPreferencesController', [
            '$scope', '$stateParams', '$state', 'CareerPortalDataBus', 'positionsDataService',
            function ($scope, $stateParams, $state, CareerPortalDataBus, positionsDataService) {

            $scope.unsubscribe = !!$stateParams.unsubscribe;

            $scope.token = HStorageManager.get({
                storageLevel:  HStorageManager.StorageLevels.SESSION,
                key: 'emailToken'
            }) || $stateParams.token;

            $scope.getJobAlertsForm = new GetJobAlertForm($scope, CareerPortalDataBus, positionsDataService);
            $scope.loading = true;

            SubscriptionAPI.getJobsAlertsSubscription($scope.token)
                .then(function (subscriptionDetails) {

                    if (subscriptionDetails.status === 'INACTIVE') {
                        hRedirect(subscriptionDetails.base_brand && subscriptionDetails.base_brand.slug || '/');
                    }

                    $scope.subscriptionDetails = subscriptionDetails;

                    $scope.getJobAlertsForm.load({
                        brand: {
                            id: subscriptionDetails.base_brand_id,
                            name: subscriptionDetails.base_brand_name,
                            type: subscriptionDetails.base_brand.type
                        }
                    }, subscriptionDetails);

                    $scope.loading = false;
                    $scope.$digest();
                }, function (err) {
                    hAlert($filter("translate")("Error"), $filter("translate")("Invalid token."));
                    console.error("Invalid token", err);
                    $scope.loading = false;
                    $scope.$digest();
                });

            $scope.updatePreferences = function () {
                $scope.updating = true;

                if ($scope.unsubscribe) {
                    SubscriptionAPI.removeSubscription($scope.subscriptionDetails.id, $scope.token)
                        .then(function () {

                            hAlert(
                                $filter("translate")("Unsubscribe from ") +
                                $scope.subscriptionDetails.base_brand_name +
                                $filter("translate")(" job alerts"),

                                $filter("translate")("You’ve been successfully unsubscribed from ") +
                                $scope.subscriptionDetails.base_brand_name +
                                $filter("translate")(" job alerts.") + '<br>' +
                                $filter("translate")(" You will never receive emails from ") +
                                $scope.subscriptionDetails.base_brand_name +
                                $filter("translate")(" in the future.")
                            );

                            setTimeout(function () {
                                hRedirect($scope.subscriptionDetails.base_brand.slug);
                            }, 5000);
                        }, function () {
                            hAlert($filter("translate")("Error"), $filter("translate")("Invalid token."));
                        });
                } else {
                    $scope.getJobAlertsForm.save($scope.subscriptionDetails.base_brand_id)
                        .then(function (data) {
                            hAlert($filter("translate")("Update job alerts preferences"), $filter("translate")("You have successfully updated your job alerts preferences."));
                            $scope.updating = false;
                            $scope.$digest();
                        });
                }
            }
        }
    ]);

})();